import React, { useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import { clearReportState } from "../utils/careNotesReportState.js";
import { TbLayoutDashboard } from "react-icons/tb";
import { LuUsers } from "react-icons/lu";
import { TbReport } from "react-icons/tb";
import { TbTemplate } from "react-icons/tb";
import { GrSchedules } from "react-icons/gr";
import { TbReportMedical } from "react-icons/tb";
// import { FiSettings } from "react-icons/fi";
import { IoIosLogOut } from "react-icons/io";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { LuUserRoundCog } from "react-icons/lu";

interface SidebarItem {
  name: string;
  path: string;
  icon: JSX.Element;
  roles?: string[];
}

export default function Sidebar({ sidebarOpen, toggleSidebar }) {
  const { signOut } = useAuthenticator((context) => [context.user]);
  const userString = localStorage.getItem("user");
  const user = userString ? JSON.parse(userString) : null;

  const userRoles = user?.userGroup || [];
  const isFieldUser = userRoles.includes("fieldUser") && userRoles.length === 1;
  const handleLogout = () => {
    signOut();
    localStorage.removeItem("user");
    // Sign-out here doesn't reload, so drop any report held in memory
    clearReportState();
  };

  const sidebarRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;
      if (
        sidebarRef.current &&
        !(sidebarRef.current as HTMLElement).contains(target)
      ) {
        toggleSidebar();
      }
    };
    if (sidebarOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [sidebarOpen, toggleSidebar]);

  const sidebarList: SidebarItem[] = [
    {
      name: "Dashboard",
      path: "/dashboard",
      icon: <TbLayoutDashboard className="sidebar__icon" />,
      roles: ["admin"],
    },
    {
      name: "Users",
      path: "/users",
      icon: <LuUsers className="sidebar__icon" />,
      roles: ["admin"],
    },
    {
      name: "Templates",
      path: "/templates",
      icon: <TbTemplate className="sidebar__icon" />,
      roles: ["admin"],
    },
    {
      name: "Rotas",
      path: "/rotas",
      icon: <GrSchedules className="sidebar__icon" />,
      roles: ["admin"],
    },
    {
      name: "Field Shift",
      path: "/field-shifts",
      icon: <GrSchedules className="sidebar__icon" />,
      roles: ["fieldUser"],
    },

    {
      name: "Medication",
      path: "/medication",
      icon: <TbReportMedical className="sidebar__icon" />,
      roles: ["admin"],
    },
    {
      name: "Reports",
      path: "/reports",
      icon: <TbReport className="sidebar__icon" />,
      roles: ["admin"],
    },
    // {
    //   name: "Settings",
    //   path: "/settings",
    //   icon: <FiSettings className="sidebar__icon" />,
    // },
    {
      name: "Admin",
      path: "/admin",
      icon: <LuUserRoundCog className="sidebar__icon" />,
      roles: ["admin"], // Only admin can access
    },
  ];

  const filteredSidebarList = isFieldUser
    ? sidebarList.filter((item) => item.name === "Field Shift")
    : sidebarList.filter(
        (item) =>
          !item.roles || item.roles.some((role) => userRoles.includes(role))
      );
  return (
    <div
      className={"sidebar__container " + (sidebarOpen ? "open" : "")}
      ref={sidebarRef}
    >
      <nav className="sidebar">
        <ul className="sidebar__list">
          {filteredSidebarList.map((list: SidebarItem) => (
            <li className="sidebar__item" key={list.name}>
              <NavLink to={list.path} onClick={toggleSidebar}>
                {list.icon}
                {list.name}
              </NavLink>
            </li>
          ))}
        </ul>

        <button className="sidebar__logout" onClick={handleLogout}>
          <IoIosLogOut className="sidebar__logout-icon" />
          <p>Logout</p>
        </button>
      </nav>
    </div>
  );
}
